import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
export default (props) => {
  const user = useSelector((state) => state.app.userData.userData);
  const [confirmdeletejob, setconfirmdeletejob] = useState(false);
  useEffect(() => {
    if (props?.loadingToapi === false) {
      setconfirmdeletejob(false);
    }
  }, [props?.loadingToapi]);
  return { setconfirmdeletejob, user, confirmdeletejob };
};
